<template>
    <b-list-group :class="darkmode ? 'SquaredTop bg-secondary' : 'SquaredTop'" v-if="anfragen != null && anfragen != undefined" >
        <b-list-group-item button :variant="darkmode ? 'dark' : ''" class="rounded-0 d-flex justify-content-between align-items-center" 
            v-for="a in anfragen"
            :key="a.id" :active="$route.query.aid != undefined && $route.query.aid == a.id"
            @click="$route.query.aid != undefined && $route.query.aid == a.id ?
            $router.push({ path: '/nachrichten'}):
            $router.push({ path: '/nachrichten', query: { aid: a.id }})" 
        >
            <div>
                <p class=" mb-0" v-if="a.teilnehmer != null">
                    <span v-if="a.teilnehmer.firstName">{{a.teilnehmer.firstName + ' ' + a.teilnehmer.lastName}}</span>
                    <span v-else v-b-popover.hover.bottomright="'Namen werden erst geteilt, wenn man auf eine Anfrage antwortet.'">Name nicht verfügbar</span>
                    <b-badge v-if="a.neueNachrichten" class="mr-3 ml-1" variant="primary" pill>
                        Neue Nachricht
                    </b-badge>
                </p>
                <p class=" mb-0" v-else>
                    User
                    <b-badge v-if="a.neueNachrichten" class="mr-3" variant="primary" pill>
                        Neue Nachricht
                    </b-badge>
                </p>
                <small v-if="a.teilnehmer != null">
                    {{a.teilnehmer.adresse.strasse}}<span v-if="a.teilnehmer.adresse.hausnummer"> {{a.teilnehmer.adresse.hausnummer}}</span>
                    <span v-if="a.teilnehmer.adresse.strasse">,</span>
                    {{a.teilnehmer.adresse.plz}} {{a.teilnehmer.adresse.ort}}
                </small>
                <small v-else>
                    hat Anfrage verlassen
                </small>
            </div>
            <b-button variant="secondary" 
                @click.stop="a.teilnehmer == undefined? verlasseAnfrageHandler(a) : showVerlassenModal(a)"
            >
                <img src="../assets/interface/trash.svg" 
                    class="mx-n1" 
                    style="width:1.8em;height:1.8em;filter:invert(1)" 
                />
            </b-button>
        </b-list-group-item>

        <b-modal ref="modal" cancelTitle="Abbrechen" title="Achtung"
            @ok="verlasseAnfrageHandler(tempAnfrage)"
        >
            Wenn du die Anfrage verlässt, kannst du nichtmehr darauf zugreifen.
        </b-modal>
    </b-list-group>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import { BListGroup, BBadge, BListGroupItem, VBPopover } from "bootstrap-vue"
import { setAlert } from '../tools'
export default {
    name: "AnfragenListe",
    components:{
        BListGroup, 
        BBadge, 
        BListGroupItem
    },
    directives:{
        'b-popover': VBPopover
    },
    data(){ return { tempAnfrage: null } },
    computed: mapGetters(['anfragen', 'user', 'darkmode']),
    methods: {
        ...mapActions(['verlasseAnfrage']),
        async verlasseAnfrageHandler(anfrage)
        {
            try {
                await this.verlasseAnfrage(anfrage)
                if(this.$route.query.aid == anfrage.id)
                    this.$router.push("/nachrichten")
            }
            catch (err) {
                setAlert(this, err.response.data, 'Verlassen der Anfrage fehlgeschlagen', 'danger')
            }
        },
        showVerlassenModal(anfrage){
            this.tempAnfrage = anfrage
            this.$refs.modal.show()
        }
    }
}
</script>